/** *
 * Fires a callback function when the element passed in is the visibility threshold
 * @param section - A html element to observe
 * @param callback - a callback function called when element is in view
 * @param threshold - A optional override to say at what visibility ratio the callback should be fired at
 */
type TCallback = (element: HTMLElement) => void;

export const fireInView = (
  section: HTMLElement,
  callback: TCallback,
  threshold = 0.5
) => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= threshold) callback(section);
      });
    },
    { threshold }
  );
  observer.observe(section);
};
